<nav class="sidebar-nav">
  <ul id="sidebarnav" class="nav-container">
    <app-rol-sidebar-item
      *ngFor="let item of sidebarnavItems"
      [item]="item"
      class="nav-item">
    </app-rol-sidebar-item>
  </ul>
</nav>
